export enum RoleType {
    USER,
    ADMIN,
    SUPER_ADMIN
 }
export interface ILink{
    to: string;
}